<template>
  <div class="container" v-show="loaded">
    <div class="res_head">
      <div class="res_head__fixed">
        <div class="res_head__fixed__box">
          <div class="res_header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="res_header__fixed__center">
            <div class="enname">{{stadium_current.en_name}}</div>
            <div class="chname">{{stadium_current.name}}</div>
          </div>
          <div class="res_header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="vertical">

      <van-swipe class="vertical_item" vertical ref="swiper" :show-indicators="false" :loop="false" :lazy-render="true" :initial-swipe="initialswipe" @change="verticalSwiper">
        <van-swipe-item v-for="(stadiumItem,stadiumIndex) in stadium_list" :key="stadiumIndex" class="vertical_item_bock">

          <van-swipe :loop="true" :show-indicators="false" class="level">
            <van-swipe-item v-for="(levelItem,levelIndex) in stadiumItem.imgs" :key="levelIndex" v-lazy:background-image='levelItem' class="level_item">
              <div class="bglevel_item" v-lazy:background-image='levelItem'></div>
              <!-- 主蒙版 -->
              <div @click="closeAllTemplate()" class="level_item_mask"></div>
              <!-- 做蒙版 -->
              <div @click="closeAllTemplate()" class="level_item_leftmask"></div>
              <!-- tag -->
              <div @click="closeAllTemplate()" class="level_item_num">{{levelIndex+1}}<label>/{{stadiumItem.imgs.length}}</label></div>
              <!-- arrow -->
              <img @click="closeAllTemplate()" class="level_item_carousel" src="../../assets/images/base/arrows_carousel_icon.png" />
              <!-- address -->
              <div @click="closeAllTemplate()" class="reserves_fullpage_first_point" v-if="levelIndex==0">
                <div>
                  <div class="reserves_fullpage_first_point_name">{{stadiumItem.name}}</div>
                  <div class="reserves_fullpage_first_point_enname">{{stadiumItem.en_name}}</div>
                  <div class="reserves_fullpage_first_point_distance" v-if="stadiumItem.distance != -1">
                    <div class="reserves_fullpage_first_point_distance_icon"></div>
                    距离{{stadiumItem.distance}}
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <!-- tag -->
          <div @click="closeAllTemplate()" class="level_item_tag">
            <label v-for="(tagItem,tagIndex) in stadiumItem.tag_arr">{{tagItem}}</label>
          </div>

        </van-swipe-item>
      </van-swipe>
      <!-- 左侧预约、视频、介绍功能按钮 -->
      <div class="vertical_function">
        <div class="vertical_function_item">
          <img src="../../assets/images/base/order.png" />
          <div>预约</div>
          <button @click.stop.prevent="toCreateOrder()" v-preventReClick></button>
        </div>
        <div v-if="stadium_current.video == '' || stadium_current.video == null || stadium_current.video == undefined"></div>
        <div v-else class="vertical_function_item">
          <img src="../../assets/images/base/video.png" />
          <div>视频</div>
          <button @click.stop.prevent="toOpenVideo()" v-preventReClick></button>
        </div>
        <div class="vertical_function_item">
          <img src="../../assets/images/base/description.png" />
          <div>介绍</div>
          <button @click.stop.prevent="toOpenDesc()" v-preventReClick></button>
        </div>
      </div>
      <img @click="switchUpArrow()" class="vertical_uoArrow" src="../../assets/images/base/next_hotel.gif" />
      <!-- 预约日期弹出层 -->
      <div :class="order_panel_status?'order_panel order_active':'order_panel'">
        <div class="order_block">
          <div @click="closeAllTemplate()" class="order_block_close"></div>
          <!-- 预约日期标题 -->
          <div class="order_block_title">
            <div v-for="(orderItem,orderIndex) in order_title_arr" @click="switchOrderTitle(orderItem)" class="order_block_title_lab" :style="'width: calc(100% / '+order_title_arr.length+');'">
              <div>
                {{orderItem}}
                <label :class="[{'order_block_title_lab_item_lable':order_title==orderItem}]"></label>
              </div>
            </div>
          </div>
          <div class="clearboth"></div>
          <!-- 健身模块 -->
          <div v-show="order_title=='沸健身'">
            <div class="order_block_dateOrder">
              <div :class="[{'order_fit_son_liu':order_fit_arr.length==6},{'order_fit_son_qi':order_fit_arr.length==7},{'order_fit_son_ba':order_fit_arr.length==8},{'order_fit_son_jiu':order_fit_arr.length==9},'order_son']">
                <div v-for="(item_fit,index_fit) in order_fit_arr" @click="selectFitDate(item_fit,index_fit)" :id="'anchor'+index_fit" :class="[{'order_son_item_select':select_fit_index==index_fit},'order_son_item order_son_item_posi']">

                  <div v-show="select_fit_index != index_fit" :class="[{'order_son_item_titleempty':item_fit.free_cnt==0},'order_son_item_title']">{{item_fit.week}}</div>
                  <div v-show="select_fit_index == index_fit" :class="[{'order_son_item_titleSelect':item_fit.free_cnt>0},'order_son_item_title']">{{item_fit.week}}</div>

                  <div v-show="item_fit.free_cnt==0" :class="[{'order_son_item_itemempty':item_fit.free_cnt==0},'order_son_item_item']">{{(item_fit.date).substring(5,10)}}</div>
                  <div v-show="item_fit.free_cnt>0" :class="[{'order_son_item_itemnoempty':item_fit.free_cnt>0},'order_son_item_item']">{{(item_fit.date).substring(5,10)}}</div>

                  <img v-show="item_fit.free_cnt==0" class="order_son_item_posi_icon" src="../../assets/images/base/appointfull_icon.png" />

                </div>
              </div>
            </div>
            <div @click="tocreateOrderO()" class="order_son_submit">预约游泳健身</div>
          </div>
          <!-- 瑜伽模块 -->
          <div v-show="order_title=='翡瑜伽'">
            <div class="order_yoga_date">
              <div :style="'transform: translateX(-'+ 22.66666667*select_yoga_transform +'vw)'" :class="[{'order_yoga_sonliu':order_yoga_arr.length==6},{'order_yoga_sonba':order_yoga_arr.length==8},{'order_yoga_sonjiu':order_yoga_arr.length==9},'order_yoga_son']">
                <div v-for="(item_yoga,index_yoga) in order_yoga_arr" @click="selectCourse(item_yoga,index_yoga)" :id="'anchoryoga'+index_yoga" :class="[{'order_yoga_date_item_select':index_yoga==select_yoga_index},'order_yoga_date_item order_son_item_posi']">

                  <div v-show="item_yoga.courses.length !=0" :class="[{'order_yoga_date_item_dateselect':select_yoga_index==index_yoga},'order_yoga_date_item_date']">{{(item_yoga.date).substring(5,10)}}</div>
                  <div v-show="item_yoga.courses.length ==0" :class="[{'order_yoga_date_item_dateempty':item_yoga.courses.length ==0},'order_yoga_date_item_date']">{{(item_yoga.date).substring(5,10)}}</div>

                  <div :class="[{'order_yoga_date_item_itemempty':item_yoga.courses.length==0},'order_yoga_date_item_item']">{{item_yoga.week}}</div>

                  <!-- <img v-show="item_yoga.courses.length ==0" class="order_son_item_posi_icon" src="../../assets/images/base/appointfull_icon.png" /> -->

                </div>
              </div>
            </div>
            <div class="order_yoga_course_title">选择课程</div>
            <img v-show="order_yoga_arr_course.length==0" class="order_yoga_course_empty" src="../../assets/images/base/noclass_emptystate.png" />
            <div v-show="order_yoga_arr_course.length>0">
              <div v-for="(yoga_course_item,yoga_course_index) in order_yoga_arr_course" @click="selectYogaCourse(yoga_course_item)" :class="[{'order_yoga_course_block_select':current_yoga_course==yoga_course_item},'order_yoga_course_block']">
                <div class="order_yoga_course_block_title">
                  {{yoga_course_item.sd_course_name}}&nbsp;
                  <label>{{(yoga_course_item.start_time).substring(11,16)}}-{{(yoga_course_item.end_time).substring(11,16)}}</label>
                </div>
                <div class="order_yoga_course_block_des">
                  难度指数
                  <van-rate v-model="yoga_course_item.difficulty_grade" allow-half :icon="imgstar" :void-icon="imgstarno" readonly size='3vw' gutter='3' />
                  <label>{{yoga_course_item.order_cnt}}/{{yoga_course_item.galleryful}}人</label>
                </div>
                <div class="order_yoga_course_block_last">
                  仅剩<label class="order_ycbl_num">{{yoga_course_item.galleryful - yoga_course_item.order_cnt}}</label>个名额
                  <div v-show="yoga_course_item.over_order_time==0" class="order_ycbl_over">
                    <!-- <img src="../../assets/images/base/order_finish.png" /> -->
                    预约已结束
                  </div>
                </div>
              </div>
            </div>
            <div @click="yogaToCreateOrder()" class="order_yoga_submit">预约瑜伽课程</div>
          </div>
        </div>
      </div>
      <!-- 介绍弹出层 -->
      <div :class="desc_status?'desc desc_avtive animated fadeInUp':'desc animated fadeOutDown'">
        <div class="desc_cont">
          <div class="desc_cont_address">{{stadium_current_detail.address}}</div>
          <div class="desc_cont_serves">
            <div class="desc_title">酒店服务</div>
            <div class="desc_Service_cont">
              <div v-for="(services_item,services_index) in services_arr" @click="clickServiceDesc(services_item)" class="desc_Service_cont_item">
                <img :src="servicesimg[services_item]" />
                {{services[services_item]}}
              </div>
              <div class="clearboth"></div>
            </div>
            <div v-show="services_status" v-html="services_txt" class="desc_Service_detailDesc"></div>
          </div>
          <div v-show="business_time_status" class="desc_cont_businesstime">
            <div class="desc_cont_businesstime_title">营业时间</div>
            <div v-html="stadium_current_detail.business_time" class="desc_cont_businesstime_cont"></div>
          </div>
          <div class="desc_cont_businesstime">
            <div class="desc_cont_businesstime_title">预约说明</div>
            <div v-html="stadium_current_detail.book_tip" class="desc_cont_businesstime_cont"></div>
          </div>

          <div class="desc_cont_businesstime desc_cont_businesstime_bott">
            <div class="desc_cont_businesstime_title">酒店描述</div>
            <div v-html="stadium_current_detail.introduce" class="desc_cont_businesstime_cont"></div>
          </div>
          <div v-show="desc_status" class="desc_cont_close">
            <!-- <img @click="closeAllTemplate()"  /> -->
            <div @click="closeAllTemplate()" class="desc_cont_close_close">
              <img src="../../assets/images/base/icon_close.png" />
              关闭
            </div>
            <div @click="closeAllTemplateAndOrder()" class="desc_cont_close_submi">立即预约</div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频播放 -->
    <div class="hotailVider" v-show="showVideo">
      <video id="vide" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5"
        x5-video-player-fullscreen="true" preload="auto" style="background-color: #000000;"
        :src="viderUrl" autoplay="autoplay" loop="loop"></video>
    </div>

    <img @click="swiperleft()" v-show="showVideo" class="hotailViderMask_close" src="../../assets/images/base/video_close_white.png" /><!-- 关闭按钮 -->
    <v-touch v-on:swipeleft="swiperleft" v-on:swiperight="swiperright">
      <div @click="pauseVideo()" v-show="showVideo" class="hotailViderMask">
        <img v-show="showVideo_icon" src="../../assets/images/base/video_start.png" class="hotailViderMask_pause" /><!-- 暂停按钮 -->
      </div>
    </v-touch>
  </div>
</template>

<script>
  import {distance,getStValStatus} from '../../lib/utils.js'
  export default {
    data() {
      return {
        city:'',//默认城市
        stadium_list:[],//场馆列表
        stadium_current:{},//当前场馆
        stadium_current_detail:{},//当前场馆详情（请求getStadiumDetailVersionTwo接口）
        initialswipe:0,//swiper初始位置索引值
        loaded:false,//加载结束
        order_panel_status:false,//预约面板状态
        order_title_arr:[],//当前场馆有的运动类型
        order_title:'',//当前选中的健身类型
        order_fit_arr:[],//可预约健身日期
        order_yoga_arr:[],//可预约瑜伽日期
        order_yoga_arr_course:[],//当前选择的日期瑜伽课程
        imgstar:require('../../assets/images/base/star.png'),//评分(选中)
        imgstarno:require('../../assets/images/base/star_none.png'),//评分(未选中)
        desc_status:false,//介绍面板状态
        services_arr:[],
        services: {
          "101": "免费停车",
          "102": "收费停车",
          "103": "免费洗浴",
          "104": "收费洗浴",
          "105": "免费衣柜",
          "106": "收费衣柜",
          "107": "免费餐饮",
          "108": "收费餐饮",
          "109": "免费教练",
          "110": "收费教练",
          "111": "购物",
          "112": "WIFI",
          "113": "器具租赁",
          "114": "游泳池",
          "115": "力量器械",
          "116": "练操房",
          // "117": "住宿"
        },
        servicesimg: {
          "101": require('../../assets/images/base/hotel_park.png'),
          "102": require('../../assets/images/base/hotel_park_money.png'),
          "103": require('../../assets/images/base/hotel_bathing.png'),
          "104": require('../../assets/images/base/hotel_bathing_money.png'),
          "105": require('../../assets/images/base/hotel_wardrobe.png'),
          "106": require('../../assets/images/base/hotel_wardrobe_money.png'),
          "107": require('../../assets/images/base/hotel_eating.png'),
          "108": require('../../assets/images/base/hotel_eating_money.png'),
          "109": require('../../assets/images/base/hotel_coach.png'),
          "110": require('../../assets/images/base/hotel_coach_money.png'),
          "111": require('../../assets/images/base/hotel_shopping.png'),
          "112": require('../../assets/images/base/hotel_wifi.png'),
          "113": require('../../assets/images/base/hotel_rent.png'),
          "114": require('../../assets/images/base/hotel_pool.png'),
          "115": require('../../assets/images/base/hotel_power_equipment.png'),
          "116": require('../../assets/images/base/hotel_practicehouse.png'),
          // "117": "住宿"
        },
        business_time_status:false,//营业时间状态
        showVideo:false,//视频状态
        viderUrl:'',//视频链接
        showVideo_icon:false,//视频暂停icon
        services_txt:'',//服务类型的详细描述
        services_status:false,//服务类型状态
        services_settimeout:null,//服务类型定时器
        select_fit_date:null,//选择的健身日期
        select_fit_index:-1,//选择的健身索引
        select_yoga_date:null,//选择的瑜伽日期
        select_yoga_index:-1,//选择的瑜伽索引
        select_yoga_transform:0,//瑜伽课程日期默认往x轴偏移
        current_yoga_course:null,//瑜伽课程
        sd_area_id:'',//场地id,健身下单需要
        user_card_list:[],//用户卡列表
        yogaoffset_secret:-1,
      }
    },
    created() {
      // this.order_panel_status=false

    },
    activated() {
      if(sessionStorage.getItem('fullpage')){
        this.initialswipe=JSON.parse(sessionStorage.getItem('fullpage'))
        sessionStorage.removeItem('fullpage')
        // console.log('没')
      }else{
        this.stadium_list=[]
        this.order_panel_status=false
        this.getStadium()
      }
      if(localStorage.getItem('token')){
        this.userCardList()
      }
      this.closeAllTemplate()

      // 重置video
      this.showVideo=false
      this.viderUrl=''
    },
    mounted() { },
    methods: {
      // 获取酒店列表
      getStadium(){
        var $this = this
        // this.$loading('正在获取酒店信息~');

        var longitude = ''
        var latitude = ''
        if (localStorage.getItem("curPosition")) {
          let curPosition = JSON.parse(localStorage.getItem("curPosition"));
          longitude = curPosition.longitude;
          latitude = curPosition.latitude;
        }
        let param = {
          page: this.pages,
          pageSize: this.pageSize,
          latitude: latitude,
          longitude: longitude,
          stadium_brand_id:this.$route.params.stadium_brand_id
        }
        // console.log(param)
        var qs = require('qs');
        let url = this.api.userApi.getStadiums
        // let url = this.api.userApi.getStadiumsVersionTwo
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          console.log(result)
          // console.log(result.data.lists)
          // console.log($this.$route.params)
          // result.data.stadiums
          if(result.code==0){
            var curPosition=localStorage.getItem('curPosition')
            var stadium_id=''
            for (var i = 0; i < result.data.lists.length; i++) {
              // 计算获取到酒店与自己的距离
              if(curPosition){
                result.data.lists[i].distance=distance((JSON.parse(curPosition)).latitude,(JSON.parse(curPosition)).longitude,result.data.lists[i].latitude,result.data.lists[i].longitude)
              }else{
                result.data.lists[i].distance=-1
              }
              // 根据url中stadium_id，判断应该swiper应该显示的位置
              if($this.$route.params.stadium_id==result.data.lists[i].stadium_id){
                stadium_id=result.data.lists[i].stadium_id
                $this.stadium_current=result.data.lists[i]
                $this.initialswipe=i
              }
            }
            // console.log($this.stadium_current)
            $this.stadium_list=result.data.lists
            console.log($this.stadium_list)

            $this.loaded=true
          }else{
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })



        return

      },
      // 垂直轮播，每一页轮播结束后触发
      verticalSwiper(e){
        var $this=this
        // // console.log(e)
        // // console.log(this.stadium_list)
        this.closeAllTemplate()
        this.stadium_current=this.stadium_list[e]
        this.sd_area_id=''//清除上一次酒店的场馆id
        // // console.log(this.city_list)
        if(e+1==this.stadium_list.length){
          this.$toast('更多五星酒店即将上线');
        }
        setTimeout(function(){
          $this.initialswipe=e
        },100)
      },
      // 打开预约面板前的判断
      toCreateOrder(){
        var $this = this
        // // console.log(this.stadium_current)
        // // console.log(this.stadium_current.name)
        // this.order_panel_status=!this.order_panel_status

        // 判断当前swiper的索引值
        this.$loading('正在加载');

        if(localStorage.getItem('token')){

          let param = {
            token: localStorage.getItem("token")
          }
          var qs = require('qs');
          let url = this.api.userApi.getInfo
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // // console.log(result)
            if (result.data) {
              if(getStValStatus(result.data.user.name).code==0){
                // console.log(result.data.user.name)
                var init_swiper=0
                for (var i = 0; i < $this.stadium_list.length; i++) {
                  if($this.stadium_current==$this.stadium_list[i]){
                    init_swiper=i
                  }
                }
                $this.$loading.close()
                $this.$router.push({
                  name:'realname',
                  params:{
                    initialswipe:init_swiper
                  }
                })
              }else{
                // // console.log('已经实名，继续下一步')
                // // console.log($this.stadium_current)
                $this.$loading.close()
                if($this.stadium_current.is_business==0 && getStValStatus($this.stadium_current.business_tip).stat==true){
                  this.$dialog.alert({
                    title: '温馨提示',
                    message: $this.stadium_current.business_tip,
                    confirmButtonColor: '#544590'
                  }).then(() => {

                  });
                  return
                }
                if(getStValStatus($this.stadium_current.business_tip).stat==true){
                  this.$dialog.alert({
                    title: '温馨提示',
                    message: $this.stadium_current.business_tip,
                    confirmButtonColor: '#544590'
                  }).then(() => {

                  });
                }
                $this.toCreateOrderOpen()
              }
            } else {
              $this.$loading.close()
              $this.$toast(result.msg)
              $this.$router.push({
                name:'login'
              })
            }
          }).catch((error) => {
            console.warn(error)
            $this.$loading.close()
            // $this.$toast('error');
            $this.$router.push({
              name:'login'
            })
          })
        }else{
          $this.$loading.close()
          this.$router.push({
            name:'login'
          })
        }
      },
      // 打开预约面板
      toCreateOrderOpen(){
        // console.log('打开')
        this.getCurrentAreaId()
        this.order_title_arr=[];//清空原来已加载的数据
        this.select_fit_date=null;//选择的健身日期
        this.select_fit_index=-1;//选择的健身索引
        this.select_yoga_date=null;//选择的瑜伽日期
        this.select_yoga_index=-1;//选择的瑜伽索引
        this.order_yoga_arr_course=[];//课程数据清空
        this.order_fit_arr=[];//可预约健身日期
        this.order_yoga_arr=[];//可预约瑜伽日期
        this.current_yoga_course=null;//瑜伽课程
        this.select_yoga_transform=0;//瑜伽课程日期默认往x轴偏移
        this.yogaoffset_secret=-1
        // console.log(this.stadium_current)
        this.$loading('正在加载');
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }

        // console.log(param)
        // // console.log(this.initialswipe)
        // return
        var qs = require('qs');
        let url = this.api.userApi.getFityogastocks
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            // 标题模块
            if(result.data.fit.length>0){//&&$this.user_card_list.length>0
              $this.order_title_arr.push('沸健身')
            }
            if(result.data.yoga.length>0){//&& $this.user_card_list.length>0
              $this.order_title_arr.push('翡瑜伽')
            }
            $this.order_title=$this.order_title_arr[0]//'沸健身'//初始化健身面板显示的健身类型
            // ====沸健身====
            $this.order_fit_arr=result.data.fit
            // 默认选中第一个可预订日期
            for (var i = 0; i < result.data.fit.length; i++) {
              if(result.data.fit[i].free_cnt>0){
                $this.select_fit_index=i
                $this.select_fit_date=result.data.fit[i]
                break;
              }
            }
            if($this.select_fit_index>=0){
              var offset_left=0
              // if($this.select_fit_index==0){
              //   offset_left=$this.select_fit_index
              // }else if($this.select_fit_index>0 && $this.select_fit_index<6){
              //   offset_left=$this.select_fit_index+3
              // }else{
              //   offset_left=result.data.fit.length-1
              // }
              offset_left=$this.select_fit_index+3
              if(offset_left+1>=result.data.fit.length){
                offset_left=result.data.fit.length-1
              }
              var anchor='anchor'+offset_left
              // $this.$refs.anchor.scrollIntoView()
              // 健身模块偏移
              setTimeout(function(){
                $this.$el.querySelector('#'+anchor).scrollIntoView();
              },500)
            }



            // ====翡瑜伽====
            if(result.data.yoga.length>0){
              $this.order_yoga_arr=result.data.yoga
              $this.order_yoga_arr_course=result.data.yoga[0].courses

              var pdate=new Date()
              var pdate_year=pdate.getFullYear()
              var pdate_month=pdate.getMonth()+1
              if(pdate_month<10){pdate_month='0'+pdate_month}
              var pdate_date=pdate.getDate()
              if(pdate_date<10){pdate_date='0'+pdate_date}
              var sdate=pdate_year+'-'+pdate_month+'-'+pdate_date
              // console.log(sdate)


              for (var i = 0; i < result.data.yoga.length; i++) {
                if(result.data.yoga[i].date==sdate){
                  // console.log(i)
                  // console.log(result.data.yoga[i].date)
                  $this.select_yoga_transform=i


                  for (var j = i; j < result.data.yoga.length; j++) {
                    if(result.data.yoga[j].courses.length!=0){
                      // console.log(j)
                      $this.select_yoga_index=j
                      // $this.select_yoga_transform=j
                      $this.select_yoga_date=result.data.yoga[j]
                      $this.order_yoga_arr_course=result.data.yoga[j].courses
                      $this.current_yoga_course=null
                      break;
                    }
                  }
                }
              }
            }


            if($this.select_yoga_index>=0){
              var offset_left=0
              // if($this.select_yoga_index==0){
              //   offset_left=$this.select_yoga_index
              // }else{
              //   offset_left=$this.select_yoga_index+3
              // }
              // if(offset_left>result.data.yoga.length){
              //   offset_left=result.data.yoga.length
              // }
              // offset_left=offset_left-$this.select_yoga_transform+1
              // console.log(result.data.yoga.length)
              offset_left=$this.select_yoga_index+3
              if(offset_left+1>=result.data.yoga.length){
                offset_left=result.data.yoga.length-1
              }
              var anchoryoga='anchoryoga'+offset_left
              console.log(anchoryoga)
              // 瑜伽模块偏移
              setTimeout(function(){
                $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
              },500)

            }else{
              if($this.yogaoffset_secret>0){
                var anchoryoga='anchoryoga'+$this.yogaoffset_secret
                console.log(anchoryoga)
                // 瑜伽模块偏移
                setTimeout(function(){
                  $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
                },500)
              }
            }

            // 初始化当前日期的课程，判断有些课程是否已经过了预约日渐
            // console.log($this.order_yoga_arr_course)
            if($this.order_yoga_arr_course.length>0){
              for (var i = 0; i < $this.order_yoga_arr_course.length; i++) {
                // console.log($this.order_yoga_arr_course[i])
                // console.log($this.order_yoga_arr_course[i].start_time)

                var coursertime=(($this.order_yoga_arr_course[i].start_time).substring(0,10)).replace(/-/g,'/')
                // console.log(coursertime)
                // console.log(new Date(coursertime).setHours(0,0,0,0))
                // console.log(new Date().setHours(0,0,0,0))
                if(new Date(coursertime).setHours(0,0,0,0)>new Date().setHours(0,0,0,0)){
                  $this.order_yoga_arr_course[i].over_order_time=1//未到预约截止时间
                }else if(new Date(coursertime).setHours(0,0,0,0)==new Date().setHours(0,0,0,0)){
                  // $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间

                  var over_order_time_pre=new Date(($this.order_yoga_arr_course[i].start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
                  // 24*60*60*1000
                  // console.log()
                  if(over_order_time_pre>new Date().getTime()){
                    $this.order_yoga_arr_course[i].over_order_time=1//未到预约截止时间
                  }else{
                    $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间
                  }
                }else{
                  $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间
                }
              }
              // console.log($this.order_yoga_arr_course)
            }



            setTimeout(function(){
              $this.$loading.close()
              $this.order_panel_status=!$this.order_panel_status
            },500)
          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
        // ==================================================================================================

      },
      // 获取场馆id
      getCurrentAreaId(){
        var $this=this
        // this.desc_status=true
        // return
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            $this.sd_area_id=result.data.fit_service_id
          }
        }).catch((error) => {
          console.warn(error)
        })
      },
      // 切换选择健身标题
      switchOrderTitle(title){
        var $this=this
        this.order_title=title//切换健身类型

        if($this.select_fit_index>=0){
          var offset_left=0
          // if($this.select_fit_index==0){
          //   offset_left=$this.select_fit_index
          // }else if($this.select_fit_index>0 && $this.select_fit_index<6){
          //   offset_left=$this.select_fit_index+3
          // }else{
          //   offset_left=$this.order_fit_arr.length-1
          // }
          offset_left=$this.select_fit_index+3
          if(offset_left+1>=$this.order_fit_arr.length){
            offset_left=$this.order_fit_arr.length-1
          }
          var anchor='anchor'+offset_left
          // $this.$refs.anchor.scrollIntoView()
          // 健身模块偏移
          setTimeout(function(){
            $this.$el.querySelector('#'+anchor).scrollIntoView();
          },0)
        }
        if($this.select_yoga_index>=0){
          var offset_left=0
          // if($this.select_yoga_index==0){
          //   offset_left=$this.select_yoga_index
          // }else{
          //   offset_left=$this.select_yoga_index+3
          // }
          // if(offset_left>$this.order_yoga_arr.length){
          //   offset_left=$this.order_yoga_arr.length
          // }
          // offset_left=offset_left-$this.select_yoga_transform+1
          offset_left=$this.select_yoga_index+3
          if(offset_left+1>=$this.order_yoga_arr.length){
            offset_left=$this.order_yoga_arr.length-1
          }

          console.log($this.order_yoga_arr.length)
          var anchoryoga='anchoryoga'+offset_left
          console.log(anchoryoga)
          // 瑜伽模块偏移
          setTimeout(function(){
            $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
          },0)

        }else{
          if($this.yogaoffset_secret>0){
            var anchoryoga='anchoryoga'+$this.yogaoffset_secret
            console.log(anchoryoga)
            // 瑜伽模块偏移
            setTimeout(function(){
              $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
            },0)
          }
        }
      },

      switchUpArrow(){
        this.swiperTo_init=this.initialswipe
        if(this.initialswipe+1<this.stadium_list.length){
          this.swiperTo_init+=1
          this.$refs.swiper.swipeTo(this.swiperTo_init)
          this.verticalSwiper(this.initialswipe)
        }else{
          this.$toast('更多五星酒店即将上线');
        }

      },

      // 选择健身日期
      selectFitDate(item,index){
        // console.log(item)
        // console.log(index)
        if(item.free_cnt>0){
          this.select_fit_index=index
          this.select_fit_date=item
        }
      },
      // 关闭弹层
      closeAllTemplate(){
        this.order_panel_status=false;//关闭预约弹层
        this.desc_status=false
      },
      // 关闭弹框并预约
      closeAllTemplateAndOrder(){
        this.closeAllTemplate()
        this.toCreateOrder()
      },
      // 选择日期课程
      selectCourse(item,index){
        // console.log(item)

        if(item.courses.length >0){

          console.log(item.courses)
          if(item.courses.length>0){
            for (var i = 0; i < item.courses.length; i++) {
              // console.log(item.courses[i])
              // console.log(item.courses[i].start_time)
              var coursertime=((item.courses[i].start_time).substring(0,10)).replace(/-/g,'/')
              // console.log(coursertime)
              // console.log(new Date(coursertime).setHours(0,0,0,0))
              // console.log(new Date().setHours(0,0,0,0))
              if(new Date(coursertime).setHours(0,0,0,0)>new Date().setHours(0,0,0,0)){
                item.courses[i].over_order_time=1//未到预约截止时间
              }else if(new Date(coursertime).setHours(0,0,0,0)==new Date().setHours(0,0,0,0)){
                // var over_order_time_pre=parseInt((item.courses[i].start_time).substring(11,13),10)-3
                var over_order_time_pre=new Date((item.courses[i].start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
                if(over_order_time_pre>new Date().getTime()){
                  item.courses[i].over_order_time=1//未到预约截止时间
                }else{
                  item.courses[i].over_order_time=0//已经到预约截止时间
                }
              }else{
                item.courses[i].over_order_time=0//已经到预约截止时间
              }
            }
            // console.log(item.courses)
          }

          this.select_yoga_index=index
          this.select_yoga_date=item
          this.order_yoga_arr_course=item.courses
          this.current_yoga_course=null;//清空课程数据
        }
      },
      // 选择具体课程
      selectYogaCourse(item){
        // console.log(item)
        if(item.over_order_time==0){
          this.current_yoga_course=null;
          this.$toast('已过预约时间')
        }else{
          this.current_yoga_course=item
        }
      },
      // 打开介绍面板
      toOpenDesc(){
        var $this=this
        // this.desc_status=true
        // return
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            $this.desc_status=true
            var services=result.data.service.split(',')
            // console.log(services)
            $this.services_arr=services
            $this.business_time_status=getStValStatus(result.data.business_time).stat
            // desc_status
            $this.stadium_current_detail=result.data

          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })

      },
      // 打开视频播放
      toOpenVideo(){
        // console.log(this.stadium_current)
        this.showVideo=true
        this.viderUrl=this.stadium_current.video
        // console.log(this.stadium_current.video)
        this.showVideo_icon=false
        // 打开视频后，再执行播放，若不执行此操作，会导致在安卓部分机型中出现黑屏不播放情况，再次点击才会正常播放
        var vide = document.getElementById("vide")
        vide.play();
      },
      // 视频左划
      swiperleft(){
        this.stopVideo()
      },
      // 视频右划
      swiperright(){
        this.stopVideo()
      },
      // 关闭视频
      stopVideo() {
        var vide = document.getElementById("vide")
        vide.pause();
        this.viderUrl = ''
        this.showVideo=false
        this.showVideo_icon=false
      },
      // 暂停视频
      pauseVideo(){
        var vide = document.getElementById("vide")
        if (vide.paused) {
          vide.play();
          this.showVideo_icon=false
        } else {
          vide.pause();
          this.showVideo_icon=true
        }
      },
      // 获取当前服务类型的详细描述
      clickServiceDesc(item){
        var $this=this
        clearTimeout(this.services_settimeout)
        // console.log(this.stadium_current_detail)
        this.services_txt=JSON.parse(this.stadium_current_detail.service_des)[item]

        this.services_status=getStValStatus(JSON.parse(this.stadium_current_detail.service_des)[item]).stat
        this.services_settimeout=setTimeout(function(){
          $this.services_status=false
        },5000);
      },
      // 判断用户是否在黑名单中（健身）
      tocreateOrderO(){
        // console.log(this.stadium_current.stadium_id)
        // getBlacklist
        var $this=this;
        var param={
          token: localStorage.getItem("token"),
          stadium_id:this.stadium_current.stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.tocreateOrderWhiteList()
            }else{
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$toast(res.msg);
        })
      },
      // 健身去创建订单
      tocreateOrderWhiteList(){
        var $this=this
        // console.log(this.stadium_current)
        // console.log(this.select_fit_date)
        if(this.select_fit_date==null){
          this.$toast('请选择健身日期')
        }else{
          this.$loading('加载订单信息')
          // console.log(getStValStatus(this.sd_area_id))
          if(getStValStatus(this.sd_area_id).stat==false){
            this.$toast('请再次点击预约')
            return
          }
          this.stadium_current.origin_price=parseFloat(this.stadium_current.origin_price,10)*100
          sessionStorage.setItem('sd_area_id',this.sd_area_id);//创建订单：场馆id,健身下单需要
          sessionStorage.setItem('create_order_type','fit');//创建订单：类型
          sessionStorage.setItem('stadium_current',JSON.stringify(this.stadium_current));//创建订单：当前场馆信息
          sessionStorage.setItem('select_fit_date',JSON.stringify(this.select_fit_date));//创建订单：健身日期
          for (var i = 0; i < this.stadium_list.length; i++) {
            if(this.stadium_list[i].stadium_id==this.stadium_current.stadium_id){
              // console.log(i)
              sessionStorage.setItem('fullpage',i)
            }
          }
          // stadium_list
          // return
          // user_card_list
          setTimeout(function(){
            $this.$loading.close()
            if($this.user_card_list.length>0){
              $this.$router.push({
                name:'createorder',
              })
            }else{
              $this.$router.push({
                name:'createordernocard',
              })
            }
          },500)
        }
      },
      // 判断用户是否在黑名单中（瑜伽）
      yogaToCreateOrder(){
        // console.log(this.stadium_current.stadium_id)
        // getBlacklist
        var $this=this;
        var param={
          token: localStorage.getItem("token"),
          stadium_id:this.stadium_current.stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.yogaToCreateOrderWhiteList()
            }else{
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$toast(res.msg);
        })
      },
      // 健身去创建订单（瑜伽）
      yogaToCreateOrderWhiteList(){
        var $this=this
        // console.log(this.stadium_current)
        // console.log(this.select_yoga_date)
        // console.log(this.current_yoga_course)
        // return
        if(this.select_yoga_date==null || this.current_yoga_course==null){
          this.$toast('请选择瑜伽日期和课程')
        }else{

          // user_card_list
          if($this.user_card_list.length==0){
            $this.$dialog.confirm({
              title:'温馨提示',
              message: "成为《斐燃会员》即可下单瑜伽课程",
              confirmButtonColor: '#544590',
              confirmButtonText:'成为会员',
              cancelButtonText:'再想想'
            }).then(() => {
              $this.$router.push({
                name:'vip'
              })
            }).catch(() => {

            })
            return
          }
          // console.log(this.current_yoga_course)
          // var coursertime=((this.current_yoga_course.start_time).substring(0,10)).replace(/-/g,'/')
          // // var over_order_time_pre=parseInt((this.current_yoga_course.start_time).substring(11,13),10)-3
          // var over_order_time_pre=new Date((this.current_yoga_course.start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
          // if(over_order_time_pre<=new Date().getHours()&& new Date(coursertime).setHours(0,0,0,0)<=new Date().setHours(0,0,0,0)){
          //   this.$toast('亲~  已过预约时间了哦~')
          //   return
          // }

          this.$loading('加载订单信息')
          this.stadium_current.origin_price=parseFloat(this.stadium_current.origin_price,10)*100
          sessionStorage.setItem('create_order_type','yoga');//创建订单：类型
          sessionStorage.setItem('stadium_current',JSON.stringify(this.stadium_current));//创建订单：当前场馆信息
          sessionStorage.setItem('select_yoga_date',JSON.stringify(this.select_yoga_date));//创建订单：瑜伽日期
          sessionStorage.setItem('current_yoga_course',JSON.stringify(this.current_yoga_course));//创建订单：瑜伽课程
          for (var i = 0; i < this.stadium_list.length; i++) {
            if(this.stadium_list[i].stadium_id==this.stadium_current.stadium_id){
              // console.log(i)
              sessionStorage.setItem('fullpage',i)
            }
          }
          setTimeout(function(){
            $this.$loading.close()
            $this.$router.push({
              name:'createorder'
            })
          },500)
        }
      },
      // 获取用户会员卡列表
      userCardList(){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
        }
        var qs = require('qs');
        let url = this.api.userApi.getUserCards
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if (result.code == 0) {
            $this.user_card_list=result.data.cards
          } else {
            // $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .res_head{
  	position:relative;
  	z-index:12;
  	width:100%;
  	height:100*@vm_base;
  }
  .res_head__fixed{
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	background:#fff;
  	width:100%;
  	height:100*@vm_base;
  	.res_head__fixed__box{
  		display:flex;
  		width:100%;
  		height:100%;
  	}
  	.res_header__fixed__left,
  	.res_header__fixed__right{
  		width: 90*@vm_base;
  		height:100%;
  	}
  	.res_header__fixed__center{
  		width: calc(100% - 180*@vm_base);
  		height:100%;
  		// line-height:100*@vm_base;
  		text-align:center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  		.enname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 32*@vm_base;
  		  height: 40*@vm_base;
  		  line-height: 40*@vm_base;
  		  margin-top: 20*@vm_base;
  		  letter-spacing: 8*@vm_base;
  		}
  		.chname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 24*@vm_base;
  		  height: 24*@vm_base;
  		  line-height: 24*@vm_base;
  		  margin-top: 4*@vm_base;
  		}
  	}
    .back{
      float:left;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/nav_back.png) center center no-repeat;
      background-size:18*@vm_base auto;
    }
    .res_switch{
      float:right;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/Switch_photo.png) center center no-repeat;
      background-size:38*@vm_base auto;
    }
  }
  .vertical{
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    position: relative;
    .vertical_item{
      width: 100%;
      height: calc(100vh - 100*@vm_base);
      .level{
        width: 100%;
        height: calc(100vh - 100*@vm_base);
        overflow: hidden;
        .level_item{
          width: 100%;
          height: calc(100vh - 100*@vm_base);
          background-repeat: no-repeat;
          overflow: hidden;
          background-position: center center;
          // background-size: auto 100%;//原版
          background-size: cover;//新版
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .bglevel_item{
            width: 100%;
            width: 100%;
            height: calc(100vh - 100*@vm_base);
            background-repeat: no-repeat;
            background-position: center center;
            // background-size: auto 100%;//原版
            background-size: 100% calc(100vh - 100*@vm_base);//新版
          }
          .level_item_mask{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.1);
          }
          .level_item_leftmask{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 120*@vm_base;
            height: 100%;
            background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
          }
          .level_item_num{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            padding: 20*@vm_base 30*@vm_base 0 0;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #F3F3F3;
            label{
              font-size: 28*@vm_base;
              font-weight: 400;
            }
          }
          .level_item_carousel{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            width: 41*@vm_base;
            margin-top: 77*@vm_base;
            margin-right: 30*@vm_base;
          }
          .reserves_fullpage_first_point{
            position: absolute;
            left: 0;
            // top: 0;
            margin-top: -200*@vm_base;
            z-index: 2;
            min-width: 460*@vm_base;
            min-height: 334*@vm_base;
            background-image: url(../../assets/images/base/stadiumAddressbg.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            .reserves_fullpage_first_point_name{

              width: 100%;
              height: 84*@vm_base;
              line-height: 84*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              // margin-top: 52*@vm_base;
              font-size:56*@vm_base;
              font-weight:500;
              white-space: nowrap;
              color:rgba(255,255,255,1);
            }
            .reserves_fullpage_first_point_enname{
              width: 100%;
              height: 72*@vm_base;
              line-height: 72*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              font-size:44*@vm_base;
              font-weight:300;
              white-space: nowrap;
              color:rgba(199,198,204,1);
            }
            .reserves_fullpage_first_point_distance{
              width: 100%;
              height: 60*@vm_base;
              line-height: 60*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              font-size:44*@vm_base;
              font-size:24*@vm_base;
              white-space: nowrap;
              font-weight:500;
              color:rgba(255,255,255,0.7);
              .reserves_fullpage_first_point_distance_icon{
                width: 18*@vm_base;
                height: 60*@vm_base;
                float: left;
                background-image: url(../../assets/images/base/line_posi.png);
                background-size: 18*@vm_base 24*@vm_base;
                background-position: center center;
                background-repeat: no-repeat;
                margin-right: 10*@vm_base;
                // margin-left: 32*@vm_base;
              }
            }
          }
        }
      }
      .vertical_item_bock{
        position: relative;
        width: 100%;
        height: calc(100vh - 100*@vm_base);
        .level_item_tag{
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          width: calc(100% - 120*@vm_base);
          padding: 24*@vm_base 0 0 24*@vm_base;
          label{
            display: inline-block;
            padding: 8*@vm_base 24*@vm_base;
            color: #FFFFFF;
            float: left;
            font-size: 24*@vm_base;
            margin-right: 12*@vm_base;
            font-weight: 400;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 100*@vm_base 100*@vm_base 0px 100*@vm_base;
            border: 1*@vm_base solid #FFFFFF;
            margin-bottom: 24*@vm_base;
          }
        }
      }
    }
    .vertical_function{
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 3;
      width: 120*@vm_base;
      margin-bottom: 100*@vm_base;
      .vertical_function_item{
        width: 100%;
        position: relative;
        margin-bottom: 60*@vm_base;
        img{
          width: 60*@vm_base;
          margin: 0 auto;
        }
        div{
          width: 100%;
          text-align: center;
          margin-top: 2*@vm_base;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #FFFFFF;
        }
        button{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 120*@vm_base;background: none;
        }
      }
    }
    .vertical_uoArrow{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      width: 100%;
    }
    .order_panel{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 4;
      width: 100%;
      height: 0;
      max-height: calc(100vh - 120*@vm_base);
      overflow: hidden;
      overflow-y: auto;
      background: #fefefe;
      transition:all .5s ease-in;
      border-radius: 50*@vm_base 0px 0px 0px;
      .order_block{
        width: 100%;
        padding: 36*@vm_base 32*@vm_base 60*@vm_base 32*@vm_base;
        position: relative;
        .order_block_close{
          position: absolute;
          top: 0;
          right: 0;
          width: 90*@vm_base;
          height: 90*@vm_base;
          background-image: url(../../assets/images/base/icon_close.png);
          background-size: 50*@vm_base;
          background-position: center;
          background-repeat: no-repeat;
        }
        .order_block_title{
          width: 100%;
          padding: 0 89*@vm_base;
          .order_block_title_lab{
            float: left;
            div{
              width: 100*@vm_base;
              padding: 24*@vm_base 0;
              text-align: center;
              white-space: nowrap;
              margin: 0 auto;
              border-bottom:none;
              position: relative;
              label{
                display: inline-block;
                width: 100%;
                height: 8*@vm_base;
                position: absolute;
                bottom: 0;
                left: 0;
              }
              .order_block_title_lab_item_lable{
                width: 100%;
                background: #444054;
                border-radius: 12*@vm_base;
              }
            }
          }
        }
        .order_block_dateOrder{
          width: 100%;
          padding: 81*@vm_base 0 0 0;
          overflow: hidden;
          overflow-x: auto;
          &::-webkit-scrollbar{width:0px}
          .order_son{
            width: calc(170*@vm_base * 8 + 14*@vm_base);
            height: 150*@vm_base;
            margin-bottom: 118*@vm_base;
            .order_son_item{
              width: 150*@vm_base;
              height: 150*@vm_base;
              border-radius: 12*@vm_base;
              border: 1*@vm_base solid #EBEBEB;
              float: left;
              margin-right: 20*@vm_base;
              text-align: center;
              font-weight: bold;
              padding-top: 32*@vm_base;
              .order_son_item_title{
                width: 80%;
                margin-left: 10%;
                font-size: 32*@vm_base;
                color: #444054;
                background: #FFFFFF;
              }
              .order_son_item_titleempty{
                color: #C7C6CC;
                background: #FFFFFF;
              }
              .order_son_item_titleSelect{
                color: #FFFFFF;
                background: #444054;
              }
              .order_son_item_item{
                font-weight: 400;
                font-size: 28*@vm_base;
                color: #8F8C98;
              }
              .order_son_item_itemempty{
                color: #C7C6CC;
              }
              .order_son_item_itemnoempty{
                color: #8F8C98;
              }
            }
            .order_son_item_select{
              background: #444054;
            }
          }
          .order_fit_son_liu{
            width: calc(170*@vm_base * 6 + 14*@vm_base);
          }
          .order_fit_son_qi{
            width: calc(170*@vm_base * 7 + 14*@vm_base);
          }
          .order_fit_son_ba{
            width: calc(170*@vm_base * 8 + 14*@vm_base);
          }
          .order_fit_son_jiu{
            width: calc(170*@vm_base * 9 + 14*@vm_base);
          }
        }
        .order_son_submit{
          width: 100%;
          text-align: center;
          background: #444054;
          border-radius: 12*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          padding: 27*@vm_base 0;
        }
        .order_yoga_date{
          width: 100%;
          padding: 81*@vm_base 0 0 0;
          overflow: hidden;
          overflow-x: auto;
          &::-webkit-scrollbar{width:0px}
          .order_yoga_son{
            width: calc(170*@vm_base * 7 + 14*@vm_base);
            height: 150*@vm_base;
            margin-bottom: 60*@vm_base;
            .order_yoga_date_item{
              width: 150*@vm_base;
              height: 150*@vm_base;
              border: 1*@vm_base solid #EBEBEB;
              float: left;
              margin-right: 20*@vm_base;
              text-align: center;
              font-weight: bold;
              color: #444054;
              padding-top: 32*@vm_base;
              border-radius: 12*@vm_base;
              .order_yoga_date_item_date{
                width: 80%;
                margin-left: 10%;
                font-size: 32*@vm_base;
                color: #444054;
                background: #FFFFFF;
              }
              .order_yoga_date_item_dateselect{
                color: #FFFFFF;
                background: #444054;
              }
              .order_yoga_date_item_dateempty{
                background: #FFFFFF;
                color: #C7C6CC;
              }
              .order_yoga_date_item_item{
                font-weight: 400;
                font-size: 28*@vm_base;
                color: #8F8C98;
              }
              .order_yoga_date_item_itemempty{
                color: #C7C6CC;
              }
            }
            .order_yoga_date_item_select{
              background: #444054;
            }
          }
          .order_yoga_sonba{
            width: calc(170*@vm_base * 8 + 14*@vm_base);
          }
          .order_yoga_sonjiu{
            width: calc(170*@vm_base * 9 + 14*@vm_base);
          }
          .order_yoga_sonliu{
            width: calc(170*@vm_base * 6 + 14*@vm_base);
          }
        }
        .order_yoga_course_title{
          width: 100%;
          font-size: 32*@vm_base;
          font-weight: bold;
          color: #444054;
          margin-bottom: 24*@vm_base;
        }
        .order_yoga_course_empty{
          width: 100%;
        }
        .order_yoga_course_block{
          width: 100%;
          background: #FFFFFF;
          border-radius: 12*@vm_base;
          border: 1*@vm_base solid #EBEBEB;
          padding: 32*@vm_base;
          margin-bottom: 24*@vm_base;
          position: relative;
          // display: fl;
          .order_yoga_course_block_title{
            width: 100%;
            height: 32*@vm_base;
            font-size: 32*@vm_base;
            font-weight: bold;
            color: #444054;
            line-height: 32*@vm_base;
            label{
              display: inline-block;
              height: 32*@vm_base;
              line-height: 32*@vm_base;
              font-size: 24*@vm_base;
              font-weight: 400;
              color: #8F8C98;
            }
          }
          .order_yoga_course_block_des{
            width: 100%;
            margin-top:24*@vm_base;
            height: 24*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #8F8C98;
            line-height: 24*@vm_base;
          }
          .order_yoga_course_block_last{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: 400;
            color: #444054;
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            text-align: right;
            padding: 50*@vm_base 32*@vm_base 0 0;
            .order_ycbl_num{
              color: #F7B500;
            }
            .order_ycbl_over{
              // border: 1px solid red
              margin-top: 5*@vm_base;
              color: #c7c6cc;
              font-size: 24*@vm_base;
              line-height: 1.2;
              // img{
              //   display: inline-block;
              //   height: 26*@vm_base;
              //   vertical-align:bottom
              //   // margin-top: 10*@vm_base;
              // }
            }
          }
        }
        .order_yoga_course_block_select{
          border: 1*@vm_base solid #f7b500;
        }
        .order_yoga_submit{
          width: 100%;
          background: #444054;
          border-radius: 12*@vm_base;
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          padding: 27*@vm_base 0;
          margin-top: 36*@vm_base;
        }
      }
    }
    .order_panel.order_active{
      height: auto;
    }
    .desc{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 4;
      width: 100%;
      height: 0;
      background: #fefefe;
      transition:all .5s ease-in;
      border-radius: 50*@vm_base 0px 0px 0px;
      overflow: hidden;
      .desc_cont{
        width: 100%;
        padding: 10*@vm_base 32*@vm_base;
        position: relative;
        max-height: calc(100vh - 120*@vm_base);
        overflow: hidden;
        overflow-y: auto;
        .desc_cont_address{
          width: 100%;
          padding: 40*@vm_base 0 40*@vm_base 36*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #333333;
          background-image: url(../../assets/images/base/order_details_location.png);
          background-size: 24*@vm_base auto;
          background-position: left 45*@vm_base;
          background-repeat: no-repeat;
        }
        .desc_cont_serves{
          width: 100%;
          margin-bottom: 40*@vm_base;
          .desc_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #333333;
          }
          .desc_Service_cont{
            width: calc(100% + 12*@vm_base);
            padding: 8*@vm_base 0 0 0;
            .desc_Service_cont_item{
              width: calc(25% - 12*@vm_base);
              background: #F8F8F8;
              border-radius: 6*@vm_base;
              margin-right: 12*@vm_base;
              margin-top: 12*@vm_base;
              float: left;
              height: 72*@vm_base;
              text-align: center;
              font-size: 24*@vm_base;
              font-weight: 400;
              color: #333333;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 30*@vm_base;
              }
            }
          }
          .desc_Service_detailDesc{
            width: 100%;
            background: #F8F8F8;
            border-radius: 6*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #333333;
            padding: 30*@vm_base;
            margin: 20*@vm_base 0 0 0;
          }
        }
        .desc_cont_businesstime{
          width: 100%;
          padding-bottom: 40*@vm_base;
          .desc_cont_businesstime_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #333333;
          }
          .desc_cont_businesstime_cont{
            width: 100%;
            background: #F8F8F8;
            border-radius: 6*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #333333;
            padding: 30*@vm_base;
            margin: 20*@vm_base 0 0 0;
          }
        }
        .desc_cont_businesstime_bott{
          margin-bottom: 80*@vm_base;
        }
        .desc_cont_close{
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #FFFFFF;
          padding: 20*@vm_base 32*@vm_base;
          .desc_cont_close_close{
            float: left;
            width: 150*@vm_base;
            height: 80*@vm_base;
            border: 1*@vm_base solid #B4B3BB;
            line-height: 80*@vm_base;
            text-align: center;
            border-radius: 12*@vm_base;
            font-size: 32*@vm_base;
            color: #444054;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              height: 36*@vm_base;
            }
          }
          .desc_cont_close_submi{
            float: right;
            width: calc(100% - 180*@vm_base);
            height: 80*@vm_base;
            background: #444054;
            border-radius: 12*@vm_base;
            line-height: 80*@vm_base;
            text-align: center;
            color: #FFFFFF;
            font-size: 32*@vm_base;
          }
        }
      }
    }
    .desc.desc_avtive{
      height: auto;
      max-height: calc(100vh - 120*@vm_base);
    }
  }
  .hotailVider{
    position: absolute;
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    bottom: 0;
    left: 0;
    z-index: 5;
    video{
      width: 100%;
      height: calc(100vh - 100*@vm_base);
    }
  }
  .hotailViderMask{
    position: absolute;
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    bottom: 0;
    left: 0;
    z-index: 6;
    .hotailViderMask_pause{
      width: 60*@vm_base;
      margin: calc(50vh - 150*@vm_base) auto 0 auto;
    }
  }
  .hotailViderMask_close{
    position: absolute;
    width: 25*@vm_base;
    top: 0;
    right: 0;
    z-index: 7;
    margin-right: 30*@vm_base;
    margin-top: 130*@vm_base;
  }
  .order_son_item_posi{
    position: relative;
    .order_son_item_posi_icon{
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/reserve/resdetailBrand.vue